(()=>{
  // Lazy-load fade-in
  document.querySelectorAll('.card__media').forEach(c=>{
    c.classList.add('mn-lazy-init');
    c.querySelectorAll('img').forEach(img=>{
      if(img.complete)img.classList.add('mn-loaded');
      else img.addEventListener('load',()=>img.classList.add('mn-loaded'),{once:true});
    });
  });
  window.mnSkeleton={
    on: w=>w&&w.classList.add('is-loading'),
    off:w=>w&&w.classList.remove('is-loading')
  };
})();